import React, { createContext, useContext, useState } from 'react';
import { node } from 'prop-types';
import {
  addDeliveryAddressAPI,
  getDeliveryAddressAPI,
  updateDeliveryAddressAPI,
  deleteDeliveryAddressAPI,
} from './api-services/deliveryAddress.service';
import { localStorageKeys } from '../global/constants';
import axios from 'axios';
import { StoreHeaderDataContext } from './StoreHeaderDataProvider';

export const DeliveryAddressDataContext = createContext();

const DeliveryAddressDataProvider = ({ children }) => {
  const { onGetKitchenByZipcodeHandler } = useContext(StoreHeaderDataContext);
  const [getDeliveryAddressListResponse, setGetDeliveryAddressListResponse] = useState({
    isloading: false,
    data: null,
    success: null,
    errorMessage: null,
  });
  const [deliverAddressResponse, setDeliverAddressResponse] = useState({
    isLoading: false,
    data: null,
    success: null,
    errors: null,
    errorMessage: null,
  });

  const [updateDeliveryAddressResponse, setUpdateDeliveryAddressResponse] = useState({
    isLoading: false,
    data: null,
    success: null,
    errorMessage: null,
  });

  const [deleteDeliveryAddressResponse, setDeleteDeliveryAddressResponse] = useState({
    isLoading: false,
    data: null,
    success: null,
    errorMessage: null,
  });

  const { TOKEN, ZIPCODE_GEO_COORDINATES } = localStorageKeys;
  const hasTokens = localStorage.getItem(TOKEN);

  // flag to show/hide the googleAddressInput or manual input component based on the google API availability
  const [showGoogleAddrsesInput, setShowGoogleAddrsesInput] = useState(true);

  // Google Address Selected State
  const [googleAddress, setGoogleAddress] = useState({});
  const [manualEnteredAddress, setManualEnteredAddress] = useState({ addressType: 'Residential' });
  const setManualEnteredAddressHandler = ({ key, value }) => {
    setManualEnteredAddress({ ...manualEnteredAddress, [key]: value });
  };

  /**
   * stores the google address predictions array for each key search
   * if the data for the key is found in this state, then the data or predictions are served from here
   * else a google api for fetching the predictions will happen and the res.predictions with the keys are stored
   */
  const [googleAddressPredictions, setGoogleAddressPredictions] = useState({});
  const setGoogleAddressPredictionsHandler = ({ key, predictions }) => {
    const data = {
      ...googleAddressPredictions,
      [key]: { created: new Date(), predictions },
    };
    // console.log("SETING ....", key, predictions, data);
    setGoogleAddressPredictions(data);
  };

  const addDeliveryAddressApiHandler = async (payload) => {
    try {
      await setDeliverAddressResponse({
        loading: true,
        data: null,
        success: null,
        errors: null,
        errorMessage: '',
      });

      if (hasTokens) {
        axios.defaults.headers.common.Authorization = `Bearer ${hasTokens}`;
      }
      const response = await addDeliveryAddressAPI(payload);

      if (response.hasError) {
        await setDeliverAddressResponse({
          loading: false,
          data: null,
          success: !response.hasError,
          errors: response.hasError,
          errorMessage: response.message,
        });
        return response.data;
      }

      if (response.data.success) {
        setDeliverAddressResponse({
          loading: false,
          data: response.data,
          success: response.data.success,
          errors: false,
          errorMessage: null,
        });

        // Setting geocoordinates
        await localStorage.setItem(
          ZIPCODE_GEO_COORDINATES,
          response?.data?.data?.Geolocation?.coordinates // we are taking coordinates from customer address
        );

        return response.data;
      }

      if (response.data.success === false) {
        await setDeliverAddressResponse({
          loading: false,
          data: response.data,
          success: response.data.success,
          errors: true,
          errorMessage: response.data.errors,
        });

        return response.data;
      }
    } catch (error) {
      console.log(' catch block for deliveryAddressAPI', error);
      setDeliverAddressResponse({
        data: null,
        isLoading: false,
        errors: true,
        errorMessage: error,
        success: false,
      });
    }
  };

  const getDeliveryAddressApiHandler = async (email) => {
    try {
      setGetDeliveryAddressListResponse({
        loading: true,
        data: null,
        success: null,
        errorMessage: '',
      });

      const gettingToken = localStorage.getItem(TOKEN);

      if (gettingToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`;
      }

      const response = await getDeliveryAddressAPI(email);

      if (response.hasError) {
        await setGetDeliveryAddressListResponse({
          loading: false,
          data: null,
          success: !response.hasError,
          errorMessage: response.message,
        });
        return response;
      }

      if (response.data.success) {
        setGetDeliveryAddressListResponse({
          loading: false,
          data: response.data,
          success: response.data.success,
          errorMessage: null,
        });
      }
      if (response.data.success === false) {
        await setGetDeliveryAddressListResponse({
          loading: false,
          data: response.data,
          success: response.data.success,
          errorMessage: response.data.ErrorMessage,
        });
      }

      return response;
    } catch (error) {
      console.log(' catch block for deliveryAddressAPI', error);
      setGetDeliveryAddressListResponse({
        data: null,
        isLoading: false,
        errorMessage: error,
        success: false,
      });
    }
  };

  const updateDeliveryAddressApiHandler = async (payload, list) => {
    try {
      setUpdateDeliveryAddressResponse({
        loading: true,
        data: null,
        success: null,
        errorMessage: null,
      });

      const gettingToken = localStorage.getItem(TOKEN);

      if (gettingToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`;
      }
      const response = await updateDeliveryAddressAPI(payload);

      if (response.hasError) {
        await setUpdateDeliveryAddressResponse({
          loading: false,
          data: null,
          success: !response.hasError,
          errorMessage: response.message,
        });
        return;
      }

      if (response.data.success) {
        setUpdateDeliveryAddressResponse({
          loading: false,
          data: response.data,
          success: response.data.success,
          errorMessage: null,
        });

        // Setting  geocoordinate in local storage for default address
        await localStorage.setItem(
          ZIPCODE_GEO_COORDINATES,
          response?.data?.data?.Geolocation?.coordinates // we are taking coordinates from customer address
        );

        // Loacl data update after sucess,this below code is to avoid refetching getDeliveryAddressApiHandler()
        const { _id } = payload;
        const findIndex = list.findIndex((el) => {
          return el._id === _id;
        });
        const tempList = list.map((el) => {
          return { ...el, isDefault_address: false };
        });

        tempList[findIndex].isDefault_address = true;

        const filerItems = tempList.filter((item) => {
          return item.isDefault_address === true;
        });

        const DefaultAddressZipcode = filerItems[0]?.Geolocation?.zipcode;

        const setLocalStorage = true;
        const kitchenByZipcodeResponse = await onGetKitchenByZipcodeHandler(
          DefaultAddressZipcode,
          setLocalStorage
        );

        await setGetDeliveryAddressListResponse({
          ...getDeliveryAddressListResponse,
          data: {
            ...getDeliveryAddressListResponse.data,
            data: tempList,
            kitchenByZipcodeResponse: kitchenByZipcodeResponse,
          },
        });
      }

      if (response.data.success === false) {
        await setUpdateDeliveryAddressResponse({
          loading: false,
          data: response.data,
          success: response.data.success,
          errorMessage: response.data.ErrorMessage,
        });
      }
    } catch (error) {
      console.log(' catch block for updateDeliveryAddressApiHandler', error);
      setUpdateDeliveryAddressResponse({
        data: null,
        isLoading: false,
        errorMessage: error,
        success: false,
      });
    }
  };

  const deleteDeliveryAddressApiHandler = async (payload, list) => {
    try {
      setDeleteDeliveryAddressResponse({
        loading: true,
        data: null,
        success: null,
        errorMessage: null,
      });

      const gettingToken = localStorage.getItem(TOKEN);
      if (gettingToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`;
      }
      const response = await deleteDeliveryAddressAPI(payload);

      if (response.hasError) {
        await setDeleteDeliveryAddressResponse({
          loading: false,
          data: null,
          success: !response.hasError,
          message: response.message,
        });
        return;
      }

      if (response.data.success) {
        await setDeleteDeliveryAddressResponse({
          loading: false,
          data: response.data,
          success: response.data.success,
          message: response.data.message,
        });

        // Loacl data update after sucess,this below code is to avoid refetching getDeliveryAddressApiHandler()
        const { _id } = payload;
        const tempList = list.filter((item) => item._id !== _id);
        await setGetDeliveryAddressListResponse({
          ...getDeliveryAddressListResponse,
          data: { ...getDeliveryAddressListResponse.data, data: tempList },
        });
      }

      if (response.data.success === false) {
        await setDeleteDeliveryAddressResponse({
          loading: false,
          data: response.data,
          success: response.data.success,
          message: response.data.message,
        });
      }
    } catch (error) {
      console.log(' catch block for deleteDeliveryAddressApiHandler', error);
      setDeleteDeliveryAddressResponse({
        data: null,
        isLoading: false,
        message: error,
        success: false,
      });
    }
  };

  return (
    <DeliveryAddressDataContext.Provider
      value={{
        showGoogleAddrsesInput,
        googleAddress,
        setGoogleAddress,
        googleAddressPredictions,
        setGoogleAddressPredictionsHandler,
        manualEnteredAddress,
        setManualEnteredAddressHandler,
        addDeliveryAddressApiHandler,
        deliverAddressResponse,
        setDeliverAddressResponse,
        setShowGoogleAddrsesInput,
        getDeliveryAddressListResponse,
        setGetDeliveryAddressListResponse,
        getDeliveryAddressApiHandler,
        updateDeliveryAddressApiHandler,
        updateDeliveryAddressResponse,
        setUpdateDeliveryAddressResponse,
        deleteDeliveryAddressApiHandler,
        deleteDeliveryAddressResponse,
        setDeleteDeliveryAddressResponse,
      }}
    >
      {children}
    </DeliveryAddressDataContext.Provider>
  );
};

DeliveryAddressDataProvider.propTypes = {
  children: node.isRequired,
};

export default DeliveryAddressDataProvider;
